import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgChartsModule } from 'ng2-charts';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import {
  TIFPEChartType,
  TrialInsightsFinancePatientsEnrolledChartService,
} from './patients-enrolled-chart.service';
import { TrialInsightsFinancePatientsEnrolledQueryService } from './patients-enrolled-query.service';
import { TrialInsightsFinancePatientsEnrolledStoreService } from './patients-enrolled-store.service';
import { TrialInsightsFinancePatientsEnrolledTableService } from './patients-enrolled-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    TooltipDirective,
    NgChartsModule,
    TrialInsightsTableComponent,
  ],
  providers: [TrialInsightsFinancePatientsEnrolledQueryService],
  selector: 'aux-trial-insights-finance-enrolled-patients',
  styleUrls: [
    '../../trial-insights.component.scss',
    './trial-insights-finance-enrolled-patients.component.scss',
  ],
  templateUrl: './trial-insights-finance-enrolled-patients.component.html',
})
export class TrialInsightsFinanceEnrolledPatientsComponent extends GenericTrialInsightsComponent<TIFPEChartType> {
  storeService = inject(TrialInsightsFinancePatientsEnrolledStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsFinancePatientsEnrolledChartService;
  queryService: TrialInsightsFinancePatientsEnrolledQueryService;
  tableService: TrialInsightsFinancePatientsEnrolledTableService;

  constructor() {
    const tableService = inject(TrialInsightsFinancePatientsEnrolledTableService);
    const chartService = inject(TrialInsightsFinancePatientsEnrolledChartService);
    const queryService = inject(TrialInsightsFinancePatientsEnrolledQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#3D444B',
      exceedMessage: 'Patients Enrolled (actual) has exceeded Patients Enrolled (expected)',
      queryService,
      tableService,
      title: 'Remaining Investigator Spend',
    });

    this.tableService = tableService;
    this.chartService = chartService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.storeService
      .getRemainingInvestigatorInfo$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
    this.queryService
      .getRemainingInvestigatorInfo$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  };
}
